export function remainingTicketLines(ticket, returns = []) {
  const used = new Map();
  const key = line => String(line.articleId) + ':' + Number(line.prixUnitaireTTC || 0);
  returns.filter(r => ['VALIDE', 'COMPTABILISE'].includes(r.statut)).forEach(r => (r.lignes || []).forEach(line => {
    used.set(key(line), (used.get(key(line)) || 0) + Number(line.quantiteRetournee || 0));
  }));
  return (ticket.lignes || []).map(line => {
    const quantity = Number(line.quantiteLivree ?? line.quantite ?? 0);
    const taken = Math.min(quantity, used.get(key(line)) || 0);
    used.set(key(line), (used.get(key(line)) || 0) - taken);
    const remaining = Math.max(0, quantity - taken);
    return { ...line, articleLibelle: line.articleNom || line.articleLibelle,
      quantiteLivree: remaining, quantiteOriginale: remaining, quantiteRetournee: remaining };
  }).filter(line => line.quantiteRetournee > 0);
}
